<template>
    <!-- pageData 通过 mixin 注入 -->
    <div :class="['epassport', pageData.isPhone ? 'phone' : 'pc']">
        <slot name="content"></slot>
    </div>
</template>

<script>
const logo = require('images/login_logo.png');
const bg = require('images/login_bg.jpg');

export default {
    data() {
        return { logo, bg };
    },
};
</script>

<style lang="scss" scoped>
.epassport {
    width: 100%;
    height: 100%;
    text-align: center;
}
</style>
